import { createSlice } from "@reduxjs/toolkit";
import {
  getAllMenuCategories,
  getMenuCategoryById,
  createMenuCategory,
  updateMenuCategory,
  deleteMenuCategory,
  reorderMenuCategories,
} from "actions/menuCategories";

const initialState = {
  categories: [],
  currentCategory: null,
  loading: false,
  reorderLoading: false,
  error: null,
};

const menuCategoriesSlice = createSlice({
  name: "menuCategories",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentCategory: (state) => {
      state.currentCategory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllMenuCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllMenuCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(getAllMenuCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getMenuCategoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMenuCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCategory = action.payload;
      })
      .addCase(getMenuCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(createMenuCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMenuCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories.push(action.payload);
      })
      .addCase(createMenuCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateMenuCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMenuCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.categories.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) state.categories[index] = action.payload;
        if (state.currentCategory?.id === action.payload.id) {
          state.currentCategory = action.payload;
        }
      })
      .addCase(updateMenuCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(deleteMenuCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMenuCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = state.categories.filter((c) => c.id !== action.payload);
      })
      .addCase(deleteMenuCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(reorderMenuCategories.pending, (state) => {
        state.reorderLoading = true;
      })
      .addCase(reorderMenuCategories.fulfilled, (state, action) => {
        state.reorderLoading = false;
        state.categories = action.payload;
      })
      .addCase(reorderMenuCategories.rejected, (state, action) => {
        state.reorderLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCurrentCategory } = menuCategoriesSlice.actions;
export default menuCategoriesSlice.reducer;
